// extracted by mini-css-extract-plugin
export default {"block":"CopyBlock_block__BZ6wX","trash":"CopyBlock_trash__YNXKY"};